module.exports = __webpack_public_path__ + "img/logo-header.65364cad.png";